import React from "react";
import Logo from "@/components/Logo";

export default function AdminLogin() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-black text-white flex items-center justify-center px-6">
      <div className="w-full max-w-md border border-zinc-900 bg-zinc-950 p-10">
        <Logo size="md" />
        <div className="mt-10 mb-2 font-mono text-[10px] tracking-[0.4em] uppercase text-zinc-500">
          Operations Console
        </div>
        <h1 className="font-display text-4xl uppercase tracking-tight">
          Admin Access
        </h1>
        <p className="mt-5 text-sm text-zinc-400 leading-relaxed">
          Restricted to authorized operators. Authentication via Google.
          Unauthorized access attempts are logged.
        </p>
        <button
          data-testid="admin-google-login"
          onClick={handleLogin}
          className="mt-10 w-full inline-flex items-center justify-center gap-3 bg-white text-black font-mono uppercase text-[11px] tracking-[0.3em] px-6 py-5 hover:bg-zinc-200 transition"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M21.6 12.2c0-.7-.1-1.4-.2-2H12v3.8h5.4c-.2 1.3-.9 2.4-2 3.1v2.6h3.2c1.9-1.7 3-4.3 3-7.5z"/>
            <path d="M12 22c2.7 0 5-.9 6.6-2.4l-3.2-2.5c-.9.6-2 .9-3.4.9-2.6 0-4.8-1.7-5.6-4.1H3.1v2.6C4.7 19.6 8.1 22 12 22z"/>
            <path d="M6.4 13.9c-.2-.6-.3-1.3-.3-1.9s.1-1.3.3-1.9V7.5H3.1C2.4 8.9 2 10.4 2 12s.4 3.1 1.1 4.5l3.3-2.6z"/>
            <path d="M12 6c1.5 0 2.8.5 3.8 1.5l2.9-2.9C16.9 3 14.7 2 12 2 8.1 2 4.7 4.4 3.1 7.5l3.3 2.6C7.2 7.7 9.4 6 12 6z"/>
          </svg>
          <span>Continue with Google</span>
        </button>
        <a
          href="/"
          className="mt-6 block text-center font-mono text-[10px] tracking-[0.3em] uppercase text-zinc-500 hover:text-white transition"
        >
          ← Return to Site
        </a>
      </div>
    </div>
  );
}
